import React, { useEffect, useState } from 'react';
import { Spinner } from 'react-bootstrap';
import SynchrotronTripsRow from './CustomComponents/SynchrotronTripsRow';
import SynchTripService from 'business/services/SynchrotronTripService';
import { SynchTripDTO } from 'business/models/Models';

export default function SynchrotronTrips() {
  const [list, setList] = useState([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    async function fetchSynchrotronTrips() {
      try {
        const synchTripService = new SynchTripService();
        const synchTrips: SynchTripDTO[] =
          await synchTripService.getLatestSynchrotronTrips();
        setList(synchTrips);
      } finally {
        setIsLoading(false);
      }
    }

    fetchSynchrotronTrips();
  }, []);

  function getRows() {
    const render = [];
    list?.map((l, index) => {
      render.push(
        <SynchrotronTripsRow
          key={`synchrotron-trips-row-${index}`}
          id={l.id}
          title={l.synchTripName}
          collectionDate={l.dataCollectionDate}
        />,
      );
    });
    return render;
  }

  return (
    <div
      id="synchrotrontrips-container"
      className="synchrotron sectionBorder"
      title={'Synchrotron Trips'}
    >
      <div id="synchrotrontrips-grid-header" className="gridColumnHeader">
        Synchrotron Trips
      </div>
      {isLoading ? (
        <div
          id="synchrotrontrips-body"
          className="synchrotronBody flex items-center justify-center"
        >
          <Spinner
            id="loading-modal-spinner-border"
            animation="border"
            className="text-[#F89723] w-8 h-8 shrink-0"
          />
        </div>
      ) : (
        <div id="synchrotrontrips-body" className="synchrotronBody">
          {getRows()}
        </div>
      )}
    </div>
  );
}
